<div>
  @if (data?.isAutoRebalEnabled && selectedModel?.allowAutoRebalOnModelUpdate === 'Paused for review') {
    <div class="block  status-message warning">
      <p>
        <span class="main">
          This portfolio is currently assigned to a model that has automated rebalancing paused for review.
        </span>
      </p>
    </div>
  }
  <div class="block">Select a target investment model.</div>
  <div class="hblock"><strong>Model</strong></div>
  @if (data && modelDetails) {
    <div class="hblock">
      <irb-dropdown-filter #irbModelDropdown (search)="getModelDropDownOptions($event)" size="30" (selection) ="onModelDropDownChange($event)" [(value)]="selectedModelDDItem"></irb-dropdown-filter>
    </div>
  }
  @if (model?.securityModelId !== null) {
    <div>
      <a  class="nav-link-text" (click)="viewPortfolioModel()">View portfolio model</a>
    </div>
  }
</div>

